import { api } from "@/builders/axios";

import { resend_otp } from "./resend-otp";
import { verify_otp } from "./verify-otp";

type PostData = {
  message: string;
  data: {
    email: string;
  };
};

const post = function (data: {
  first_name?: string;
  last_name?: string;
  staff_id?: string;
  email?: string;
  password: string;
  unique_link: string;
}) {
  return api.post<PostData>("/auth/signup", data).then(({ data }) => data);
};

export const signup = {
  post,
  resend_otp,
  verify_otp,
};
